import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { getEvaluationData, updateEvaluationGoalData } from '../../service/adminApi';
import { getTimestampToDate } from '../../utils/dateConvetor';
import './performancegoal.css';
function Goals() {
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Perfomance', isActive: true, path: '' },
        { title: 'Goals', isActive: false, path: '' },
    ];

    const [goalCount, setGoalCount] = React.useState();
    const [goalCountError, setGoalCountError] = React.useState();

    React.useEffect(() => {
        getEvaluation();
    }, []);

    const getEvaluation = async () => {
        let currentYear = getTimestampToDate(new Date(new Date().getFullYear(), 0, 1), 2);
        const response = await getEvaluationData({ year: currentYear });
        if (response.data.statusCode === 200) {
            setGoalCount(response.data.data[0].goal_count);
        }
    };

    const validateGoalCount = () => {
        let result = true;
        if (isNaN(goalCount)) {
            setGoalCountError('Numbers are only allowed');
            result = false;
        }
        if (goalCount <= 0) {
            setGoalCountError('Enter a valid goal count');
            result = false;
        }
        return result;
    };

    const updateGoal = async () => {
        if (validateGoalCount()) {
            let year = getTimestampToDate(new Date(new Date().getFullYear(), 0, 1), 2);
            let data = {
                year: year,
                goal_count: goalCount,
            };
            const response = await updateEvaluationGoalData(data);
            if (response.data.statusCode === 200) {
            }
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="admin-panel-bg p-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <h5 className="bold-text tt-bold font-18 mt-2 mb-4">Goals</h5>
                        </div>
                        <div className="col-md-12 mb-5">
                            <h5 className="font-13 mb-2 semibold-text">Goals</h5>
                            <label htmlFor="GoalValue" className="form-label hive-form-label admin-hive-goal-desc">
                                The maximum #goals to be limited in a particular evaluation period.
                            </label>
                            <input
                                id="GoalValue"
                                className="admin-hive-goal-input form-control hive-form-control"
                                type="text"
                                value={goalCount}
                                maxLength="2"
                                onChange={(e) => {
                                    setGoalCountError('');
                                    setGoalCount(e.target.value);
                                }}
                            />
                            <p className="mt-2 regular-text font-13">
                                <span className="text-danger">{goalCountError}</span>
                            </p>
                        </div>
                        <div className="col-md-12 mb-4 d-flex justify-content-end">
                            <a className="btn me-3 hive-btn-secondary">Cancel</a>
                            <a onClick={() => updateGoal()} className="btn hive-btn-primary">
                                Save
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Goals;
